import { formatCHF } from "@/lib/api";

const CATEGORIES = [["peau", "Type de peau"], ["diametre", "Diamètre"], ["forme", "Forme du cadre"]];
const DEFAULTS = { peau: "peau-chevre", diametre: "diametre-45", forme: "forme-ronde" };
const diamOrder = (id) => (id === "diametre-autre" ? 999 : Number(id.replace("diametre-", "")) || 0);

export const groupOptions = (options) => {
  const groups = {};
  (options || []).forEach((option) => { (groups[option.categorie] = groups[option.categorie] || []).push(option); });
  if (groups.diametre) groups.diametre.sort((a, b) => diamOrder(a.id) - diamOrder(b.id));
  return groups;
};

export const sanitizeDrum = (drum, options) => {
  const groups = groupOptions(options);
  const sel = {};
  CATEGORIES.forEach(([cat]) => {
    const list = groups[cat] || [];
    const current = drum?.sel?.[cat];
    sel[cat] = list.some((o) => o.id === current) ? current : (list.find((o) => o.id === DEFAULTS[cat]) || list[0])?.id;
  });
  return { sel, diametre_autre: drum?.diametre_autre || "" };
};

export const drumSupplements = (drum, options) => (options || []).filter((o) => Object.values(drum.sel).includes(o.id) && o.supplement > 0);

export const drumValid = (drum) => CATEGORIES.every(([cat]) => drum.sel[cat]) && (drum.sel.diametre !== "diametre-autre" || drum.diametre_autre.trim().length > 0);

const DrumCard = ({ index, drum, groups, onChange }) => (
  <div className="border border-wood/20 bg-white/40 p-4 sm:p-5 space-y-5" data-testid={`stage-drum-${index + 1}`}>
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-terra">Tambour {index + 1}</p>
    {CATEGORIES.map(([cat, title]) => (
      <div key={cat}>
        <span className="eyebrow block mb-2">{title}</span>
        <div className={`grid gap-2 ${cat === "peau" ? "grid-cols-2 sm:grid-cols-3" : "grid-cols-2 sm:grid-cols-4"}`} role="radiogroup" aria-label={title}>
          {(groups[cat] || []).map((option) => {
            const active = drum.sel[cat] === option.id;
            return (
              <button key={option.id} type="button" aria-pressed={active} onClick={() => onChange({ ...drum, sel: { ...drum.sel, [cat]: option.id } })} data-testid={`stage-drum-${index + 1}-${option.id}`}
                className={`text-left min-h-11 px-3 py-2 border text-sm transition-colors duration-200 ${active ? "border-earth bg-earth text-sand" : "border-wood/25 text-bark hover:border-wood/50"}`}>
                {option.libelle}{option.supplement > 0 && <span className={`block text-[11px] ${active ? "text-sand/75" : "text-fumee"}`}>+ {formatCHF(option.supplement)}</span>}
              </button>
            );
          })}
        </div>
        {cat === "diametre" && drum.sel.diametre === "diametre-autre" && (
          <input value={drum.diametre_autre} onChange={(e) => onChange({ ...drum, diametre_autre: e.target.value })} required maxLength={60} placeholder="Diamètre souhaité, p. ex. 70 cm (sous réserve de faisabilité)"
            data-testid={`stage-drum-${index + 1}-diametre-autre-input`} className="mt-2 w-full bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-terra" />
        )}
      </div>
    ))}
  </div>
);

export const DrumConfigurator = ({ drums, options, onChange }) => {
  const groups = groupOptions(options);
  const update = (index, drum) => onChange(drums.map((d, i) => (i === index ? drum : d)));
  const copyFirst = () => onChange(drums.map((d, i) => (i === 0 ? d : { ...drums[0], sel: { ...drums[0].sel } })));
  return (
    <div className="space-y-4" data-testid="stage-drums">
      {drums.length > 1 && <button type="button" onClick={copyFirst} data-testid="stage-drums-copy" className="text-xs text-terra link-line">Appliquer les choix du tambour 1 à tous les tambours</button>}
      {drums.map((drum, index) => <DrumCard key={index} index={index} drum={drum} groups={groups} onChange={(d) => update(index, d)} />)}
    </div>
  );
};
